export enum TimePeriod {
    Month = 'MONTH',
    Year = 'YEAR',
    AnnualBilledMonthly = 'ANNUALBILLEDMONTHLY',
}

export enum BillingPeriod {
    ANNUAL = 'annual',
    MONTHLY = 'monthly',
    ANNUALBILLEDMONTHLY = 'monthlyAnnual',
}

export enum BillingPeriodFromBOSS {
    ANNUAL = 'UpfrontAnnual',
    MONTHLY = 'UpfrontMonthly',
    ANNUALCONTRACT = 'MonthlyAnnual',
}

export enum BillingPeriodKey {
    ANNUAL = 'AnnualBilling',
    MONTHLY = 'MonthlyBilling',
    ANNUALCONTRACT = 'MonthlyBillingWithAnnualContract',
}

export const BillingPeriodKeyMapper: Record<string, BillingPeriod> = {
    AnnualBilling: BillingPeriod.ANNUAL,
    MonthlyBilling: BillingPeriod.MONTHLY,
    MonthlyBillingWithAnnualContract: BillingPeriod.ANNUALBILLEDMONTHLY,
}

export const BillingPeriodTimePeriodMapper: Record<BillingPeriod, TimePeriod> = {
    [BillingPeriod.ANNUAL]: TimePeriod.Year,
    [BillingPeriod.MONTHLY]: TimePeriod.Month,
    [BillingPeriod.ANNUALBILLEDMONTHLY]: TimePeriod.AnnualBilledMonthly,
}

export const TimePeriodBillingPeriodMapper: Record<TimePeriod, BillingPeriod> = {
    [TimePeriod.Year]: BillingPeriod.ANNUAL,
    [TimePeriod.Month]: BillingPeriod.MONTHLY,
    [TimePeriod.AnnualBilledMonthly]: BillingPeriod.ANNUALBILLEDMONTHLY,
}

export const BillingPeriodToBOSSBillingPeriodMapper: Record<BillingPeriod, BillingPeriodFromBOSS> = {
    [BillingPeriod.ANNUAL]: BillingPeriodFromBOSS.ANNUAL,
    [BillingPeriod.MONTHLY]: BillingPeriodFromBOSS.MONTHLY,
    [BillingPeriod.ANNUALBILLEDMONTHLY]: BillingPeriodFromBOSS.ANNUALCONTRACT,
}

export const PriceInfoPeriod: Record<string, string> = {
    UpfrontAnnual: 'annual',
    UpfrontMonthly: 'monthly',
    MonthlyAnnual: 'monthlyAnnual',
}
